import { ProductType } from '@syf-api-library/account-summary'

const PRODUCT_TYPE: Record<ProductType, ProductType> = {
  BUSINESS_RETAIL_CARD: 'BUSINESS_RETAIL_CARD',
  DUAL_CARD: 'DUAL_CARD',
  INSTALLMENT_LOAN_MONTHLY: 'INSTALLMENT_LOAN_MONTHLY',
  INSTALLMENT_LOAN_PAY_IN_FOUR: 'INSTALLMENT_LOAN_PAY_IN_FOUR',
  INSTALLMENT_LOAN_SECURED: 'INSTALLMENT_LOAN_SECURED',
  INSTALLMENT_LOAN: 'INSTALLMENT_LOAN',
  LIMITED_USE_DUAL_CARD: 'LIMITED_USE_DUAL_CARD',
  PRIVATE_LABEL: 'PRIVATE_LABEL'
}

export const SECURED_INSTALLMENT = 'SecuredInstallment'

export default PRODUCT_TYPE
